import type { FaireProductEntity } from "../../entity_types/product";

export const p_c8sp2vvxgw: FaireProductEntity = {
  token: "p_c8sp2vvxgw",
  type: "product",
  name: "Real Toddlers/Babies of ....(Custom Town) T-shirt/Onesie",
  brandToken: "b_bqub3wwmta",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/77f43c6cf11d8d7f23f98f1e8f72ec8b3303be5269ae246bba7b498a91ff87eb.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4ebe46f5b90000b50a7dec5c2c08fe8e52c29af73bd3b6cd9317ec4b1a39a4da.png",
    "https://cdn.faire.com/fastly/1e3f949f6826199e3a75addb2c79aafa2444ea5d147a40c336a8847c40dd7eae.png",
    "https://cdn.faire.com/fastly/080d8242eb0e938bfa91bd91998621248142a166a8665927472f6e0bf98653db.png",
    "https://cdn.faire.com/fastly/21b7436269a627fa505afe6160edd3f7a4eb7404e57afc8fbcb0fd06e67c4d82.png",
    "https://cdn.faire.com/fastly/5588611021a9b0e93ae7d8c1a124046357eed3232e069069dbf14ba066725ba1.png",
  ],
  priceDollars: 19.4,
  description:
    "The Real Toddlers/Babies of.....(Custom Town) Youth/Toddler T-shirt. \n\nWe use either Rabbit Skin, Gildan, or Bella Canvas t-shirts.  The brand depends on the availability of the color chosen.  The shirts are made of soft ring-spun cotton with a tear-away label and unisex fit.  \n\nKeep in mind that there are always slight variations in sizing and colors.\n\nThe shirts are made using heat transfer vinyl that we adhere to your shirt with a heat press machine.\n\nCare Instructions (a care instruction card is also included with your purchase):  \n-Machine wash cold, turning the garment inside out\n-Tumble dry low or hang to dry\n-DO NOT IRON OVER THE DESIGN\n\nIf you have any questions, please do not hesitate to message me!",
  tags: [],
  msrpDollars: 38.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:20.354Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
